import { z } from 'zod';
import { cents, optionalText } from './common';
import { checkoutSchema, shippingQuoteSchema } from './catalog';

/**
 * POST /api/public/stores/:slug/shipping/quote
 * Cotação por CEP no catálogo (página do produto, carrinho e checkout). `zoneId` só para lojas com entrega por regiões.
 */
export const publicShippingQuoteSchema = shippingQuoteSchema.extend({
  zoneId: optionalText(40),
});
export type PublicShippingQuoteInput = z.infer<typeof publicShippingQuoteSchema>;

/** Pacote avulso para simular sem produtos (medidas em cm, peso em gramas). */
export const simulatePackageSchema = z.object({
  weightGrams: z.number().int().min(1, 'Informe o peso em gramas').max(30000, 'Máximo de 30 kg por volume'),
  lengthCm: z.number().min(1).max(100, 'Máximo de 100 cm por lado'),
  widthCm: z.number().min(1).max(100, 'Máximo de 100 cm por lado'),
  heightCm: z.number().min(0.4).max(100, 'Máximo de 100 cm por lado'),
  quantity: z.number().int().min(1).max(100).default(1),
});

/**
 * POST /api/shipping/simulate (painel)
 * Simula "quanto custaria para o CEP X" com um rascunho das configurações de entrega, sem salvar.
 * Sem `items` nem `package`, usa a embalagem padrão da loja (1 unidade).
 */
export const shippingSimulateSchema = z.object({
  zipCode: z.string().trim().regex(/^\d{5}-?\d{3}$/, 'CEP inválido. Informe os 8 números.'),
  number: optionalText(20),
  zoneId: optionalText(40),
  items: checkoutSchema.shape.items.optional(),
  package: simulatePackageSchema.optional(),
  /** Valor dos produtos para as regras (pedido mínimo) e o valor declarado, quando usa `package`. */
  subtotalCents: cents.optional(),
  /** Rascunho da seção "delivery" (mesmo formato de PATCH /api/company/settings/delivery). Ausente = configuração salva. */
  delivery: z.record(z.string(), z.unknown()).optional(),
});
export type ShippingSimulateInput = z.infer<typeof shippingSimulateSchema>;

/** POST /api/shipping/geocode-store (painel) */
export const geocodeStoreSchema = z.object({
  /** Ignora o cache e consulta os serviços de CEP de novo. */
  force: z.boolean().default(false),
});
